import React, { useState } from 'react'
import { IBuffetGeneralReportResult } from 'core/api/dto/BuffetGeneralReportDto'
import { AppTableMobile } from 'components/AppTable/AppTableMobile'
import { SubTableRepresentVolume } from './SubTableRepresentVolume'
import { useTranslation } from 'react-i18next'
import { IHeaderData } from 'components/AppTable/AppTable'
import { headerDataFirstValue } from 'components/AppTable/components/headerDataFirstValue'
import { AppTableDndMobile } from 'components/AppTable/AppTableDndMobile'

const headerDataVolume = [
  {
    title: 'Наименование',
    colWidth: '15%',
    sort: 'name',
    order: 0,
    startPosition: 0,
  },
  { title: 'Станция', colWidth: '10%', order: 1, startPosition: 1 },

  { title: 'Дата', colWidth: '3%', order: 2, startPosition: 2 },
  { title: 'Время', colWidth: '3%', order: 3, startPosition: 3 },
  { title: 'Тип замера', colWidth: '5%', order: 4, startPosition: 4 },
  {
    title: 'Порядковый номер замера',
    colWidth: '6%',
    order: 5,
    startPosition: 5,
  },
  {
    title: 'Заявленное кол-во персон, человек',
    colWidth: '6%',
    sort: 'plannedPersonsAmount',
    order: 6,
    startPosition: 6,
  },
  {
    title: 'Фактическое кол-во персон, человек',
    colWidth: '6%',
    sort: 'actualPersonsAmount',
    order: 7,
    startPosition: 7,
  },
  {
    title: 'Разница кол-во персон, человек',
    colWidth: '6%',
    sort: 'personsAmountDiff',
    order: 8,
    startPosition: 8,
  },
  {
    title: 'Заявленный вес в план-меню, кг',
    colWidth: '6%',
    sort: 'plannedWeight',
    order: 9,
    startPosition: 9,
  },
  {
    title: 'Фактический общий вес, кг',
    colWidth: '3%',
    order: 10,
    startPosition: 10,
  },
  {
    title: 'Фактический вес без тары, кг',
    colWidth: '6%',
    sort: 'actualWeight',
    order: 11,
    startPosition: 11,
  },
  {
    title: 'Разница вес, кг',
    colWidth: '6%',
    sort: 'weightDiff',
    order: 12,
    startPosition: 12,
  },
  {
    title: 'Фактический вес на персону, кг',
    colWidth: '6%',
    sort: 'weightPerPerson',
    order: 13,
    startPosition: 13,
  },
  {
    title: 'Заявленный вес на персону, кг',
    colWidth: '3%',
    order: 14,
    startPosition: 14,
  },
]

interface IReportFullProps {
  reportData: IBuffetGeneralReportResult[]
  setCurrentSortValue: React.Dispatch<React.SetStateAction<string | null>>
}

export const ReportVolume = ({
  reportData,
  setCurrentSortValue,
}: IReportFullProps) => {
  const [toggleAllState, setToggleAllState] = useState<number[]>([])
  const { t } = useTranslation()
  const [headerDataDnd, setHeaderData] = useState<IHeaderData[]>(
    headerDataFirstValue('report-table-volume', headerDataVolume),
  )
  const subTableRepresentFn = (
    item: IBuffetGeneralReportResult,
    currentCol?: number,
    itemIndex?: number,
    onTouchStart?: ((e: React.TouchEvent) => void) | undefined,
    onTouchMove?: ((e: React.TouchEvent) => void) | undefined,
    width?: number,
    toggleAllState?: number[],
    headerData?: IHeaderData[],
  ) => (
    <SubTableRepresentVolume
      item={item}
      currentCol={currentCol}
      itemIndex={itemIndex}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      width={width}
      toggleAllState={toggleAllState}
      toggleAllStateFullLenght={reportData.length}
      headerData={headerData}
    />
  )

  return (
    <React.Fragment>
      {reportData && (
        <AppTableDndMobile<
          IBuffetGeneralReportResult,
          keyof IBuffetGeneralReportResult
        >
          toggleAllState={toggleAllState}
          tableName="report-table-volume"
          setHeaderData={setHeaderData}
          setToggleAllState={setToggleAllState}
          data={{
            count: 0,
            results: reportData,
            previous: '',
            next: '',
          }}
          tableWrapperClassName={'buffet-report-table'}
          tableCellClassName={'buffet-report-page-table-cell'}
          rowClassName={'buffet-report-page-table-category'}
          setCurrentSortFn={setCurrentSortValue}
          tableDataSelectors={[
            {
              renderItem: (item, index) => (
                <div
                  className={
                    index
                      ? 'violet-sticky'
                      : 'buffet-report-page-table-category-title'
                  }
                >
                  {t(item?.name)}
                </div>
              ),
            },
            {
              renderItem: (item) => <div></div>,
            },
            {
              renderItem: () => <div className={`text-end`}></div>,
            },
            {
              renderItem: () => <div className={`text-end`}></div>,
            },
            {
              renderItem: () => <div />,
            },
            {
              renderItem: () => <div className={`text-end`}></div>,
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  {+item?.plannedPersonsAmount.toFixed(1)}
                </div>
              ),
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  {+item?.actualPersonsAmount.toFixed(1)}
                </div>
              ),
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>{item?.personsAmountDiff}</div>
              ),
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  {item?.plannedWeight
                    .toFixed(3)
                    .toString()
                    .replace(/[.]/g, ',')}
                </div>
              ),
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  {item?.dimensionWeight
                    .toFixed(3)
                    .toString()
                    .replace(/[.]/g, ',')}
                </div>
              ),
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  {item?.actualWeight
                    .toFixed(3)
                    .toString()
                    .replace(/[.]/g, ',')}
                </div>
              ),
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  {item?.weightDiff?.toFixed(3).toString().replace(/[.]/g, ',')}
                </div>
              ),
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  {item?.actualWeightPerPerson
                    ?.toFixed(3)
                    .toString()
                    .replace(/[.]/g, ',')}
                </div>
              ),
            },
            {
              renderItem: (item) => (
                <div className={`text-end`}>
                  {item?.plannedWeightPerPerson
                    ?.toFixed(3)
                    .toString()
                    .replace(/[.]/g, ',')}
                </div>
              ),
            },
          ]}
          subTableRepresent={subTableRepresentFn}
          headerData={headerDataDnd}
        />
      )}
    </React.Fragment>
  )
}
